import { Keys } from "../schema";
import { Context, Effect, Layer, Schema, pipe } from "effect";
import Stripe from "stripe";
import { StripeApiConfigurationError } from "./StripeApiBaseClient";
import { SecretUnsealerService } from "@open-revenue/utils/secrets";
/**
 * Allows us to inject the actual Stripe Api Instace constructor
 */ const make = Effect.gen(function*() {
    const make = (key)=>Effect.succeed(new Stripe(key));
    const makeUnsafe = (apiKey)=>Effect.succeed(new Stripe(apiKey));
    const makeSealed = (key)=>pipe(Schema.decode(Keys.KeysSealed)(key), Effect.tapError((e)=>Effect.logError(" Unable to decode keys", e, e.stack)), Effect.mapError((e)=>new StripeApiConfigurationError(e)), Effect.tap((_)=>SecretUnsealerService), Effect.map((apiKey)=>new Stripe(apiKey)));
    return {
        make,
        makeUnsafe,
        makeSealed
    };
});
export class StripeApiInstanceBuilder extends Context.Tag("@open-revenue/stripe/StripeApiInstanceBuilder")() {
    static make = make;
    static layer = Layer.effect(this, make);
}
